package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen

enum class WeightEvaluationTypeEnum(val title: String, val value: String) {
    MICROGRAM_PER_100G(title = "µ/100g", value = "µ/100g"),
    MILLIGRAM_PER_100G(title = "mg/100g", value = "mg/100g"),
    KILOJOULE(title = "KJ", value = "KJ"),
    KILOCALORIE(title = "kcal", value = "kcal"),
    GRAM_PER_100G(title = "g/100g", value = "g/100g")
}